import React from 'react';

import { useDropzone } from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faTrash, faUpload } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import { isFileReference } from './types';

import type { DealFile } from './types';

interface Props {
  file: DealFile | null;
  onFileChange: (file: DealFile | null) => void;
}

export function PdfDropZone({ file, onFileChange }: Props) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'application/pdf',
    multiple: false,
    onDropAccepted: accepted => onFileChange(accepted[0]),
  });

  // Define a height so the component doesn't jump around when content changes during drag
  return <>
    <Empty {...getRootProps()} className="align-items-center" style={{ minHeight: 94 }} variant="inline">
      <Empty.Media>
        <FontAwesomeIcon icon={faUpload} />
      </Empty.Media>
      <Empty.Content>
        <Empty.Title>{isDragActive ? 'Drop here' : 'Upload Deal Documents'}</Empty.Title>
        {isDragActive
          ? 'Drop your document here to start.'
          : 'Upload a PDF of an agreement or deal to get started. You can also explain the deal below.'
        }
      </Empty.Content>

      <input {...getInputProps()} />
    </Empty>

    {file &&
      <div className="d-flex justify-content-between align-items-center gap-3 p-2 border rounded">
        <div className="d-flex align-items-center gap-3 text-truncate">
          <FontAwesomeIcon icon={faFilePdf} />
          <span className="text-truncate">{isFileReference(file) ? file.filename : file.name}</span>
        </div>
        <Button icon={faTrash} variant="ghost" onClick={() => onFileChange(null)} />
      </div>
    }
  </>;
}
